import { ImageCell } from '@/components/shared/ImageCell';
import type { AmenityType } from '@/config/objects/amenity-types';

interface AmenityTypeImageCellProps {
  amenityType?: AmenityType;
  size?: 'sm' | 'lg';
}

/**
 * Editable amenity type image cell component with upload and delete actions
 */
export function AmenityTypeImageCell({ amenityType, size = 'sm' }: AmenityTypeImageCellProps) {
  return (
    <ImageCell
      item={amenityType}
      endpoint="/amenity-types"
      entityName="Amenity Type"
      imageLabel="Amenity Type Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
